const contractRoutes = {
  contracts: "/contracts",
};

export default contractRoutes;
